import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import CohortsPanelFull from '../containers/CohortsPanelFull';
import CohortsPanelNarrow from '../containers/CohortsPanelNarrow';

const CohortsPanel = ({ configuration }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: CohortsPanelFull, narrow: CohortsPanelNarrow }}
  />
);

export default CohortsPanel;
